import script from "./PostNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PostNav.vue?vue&type=script&setup=true&lang=js"

import "./PostNav.vue?vue&type=style&index=0&id=06c8f43c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c8f43c"]])

export default __exports__